let code = 'cosec';
let codeAPI = 'cosec';
export const apiConstants = {
    code: `${code}`,
    codeAPI: `${codeAPI}`,
};